import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { extendTheme, NativeBaseProvider } from "native-base";
import { ToastProvider } from "react-toast-notifications";
import { HelmetProvider } from "react-helmet-async";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { initializeApp } from "firebase/app";
import {
  getString,
  fetchAndActivate,
  getRemoteConfig,
} from "firebase/remote-config";
import "react-datepicker/dist/react-datepicker.css";
import "moment/locale/es";
import "react-loading-skeleton/dist/skeleton.css";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import moment from "moment";
import "@natscale/react-calendar/dist/main.css";
import "react-phone-number-input/style.css";
import { isInIframe } from "./utils";

registerLocale("es", es);
setDefaultLocale("es");

const firebaseConfig = {
  apiKey: "AIzaSyDfSwqQi1hGNwOUV5sWX0bNAiCcpLHZ5PE",
  authDomain: "turismo-ado-71e17.firebaseapp.com",
  databaseURL: "https://turismo-ado-71e17.firebaseio.com",
  projectId: "turismo-ado-71e17",
  storageBucket: "turismo-ado-71e17.appspot.com",
  messagingSenderId: "430546055165",
  appId: "1:430546055165:web:d0b9bb0b2b6a39add23394",
  measurementId: "G-9E7E5LGXQ4",
};

const app = initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));

// TODO: Check if error on @react-google-maps/api was solved to enable again StrictMode
// TODO: Replace Pressable with button in all components

root.render(
  // FIXME <React.StrictMode>
  <HelmetProvider>
    <BrowserRouter>
      <NativeBaseProvider
        theme={extendTheme({
          config: {
            initialColorMode: "ligth",
          },
          components: {
            Heading: {
              defaultProps: {
                fontFamily: "Rams, Arial, Helvetica, sans-serif",
              },
            },
            HStack: {
              defaultProps: {
                alignItems: "center",
              },
            },
            Image: {
              defaultProps: {
                resizeMode: "contain",
              },
            },
            Pressable: {
              defaultProps: {
                _disabled: {
                  opacity: 40,
                },
              },
            },
            Text: {
              defaultProps: {
                fontSize: "md",
                fontFamily: "Rams, Arial, Helvetica, sans-serif",
              },
            },
          },
        })}
        isSSR={false}>
        <ToastProvider
          autoDismiss
          placement="top-center"
          components={isInIframe() ? { Toast: () => null } : undefined}>
          <App />
        </ToastProvider>
      </NativeBaseProvider>
    </BrowserRouter>
  </HelmetProvider>,
  // FIXME </React.StrictMode>
);

// NOTE If you want your app to work offline and load faster, you can change
// NOTE unregister() to register() below. Note this comes with some pitfalls.
// NOTE Learn more about service workers: https://cra.link/PWA
(async () => {
  const remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = moment
    .duration(1, "minute")
    .asMilliseconds();
  await fetchAndActivate(remoteConfig);
  const version = getString(getRemoteConfig(app), "version_web");
  const currentVersion = window.localStorage.getItem("version");
  if (version && currentVersion !== version) {
    await serviceWorkerRegistration.clear();
    window.localStorage.setItem("version", version);
    window.location.reload();
    return;
  }
  serviceWorkerRegistration.unregister();
})();

// NOTE If you want to start measuring performance in your app, pass a function
// NOTE to log results (for example: reportWebVitals(console.log))
// NOTE or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
